var __TEMP__ = require('./_getWrapDetails.js');var getWrapDetails = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_insertWrapDetails.js');var insertWrapDetails = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_setToString.js');var setToString = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_updateWrapDetails.js');var updateWrapDetails = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = setWrapToString;
